module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/account-delete/account-delete.component.css
// module id = ./src/app/accounts/account-delete/account-delete.component.css
// module chunks = main